import { Skeleton, Column, Row } from 'components/Blocks';

function LoadingTeam() {
  return (
    <Column gap="12">
      <Row>
        <Skeleton width={195} height={45} />
      </Row>

      <Skeleton quantity={2} width="100%" height={45} />

      <Column>
        <Skeleton quantity={2} width="100%" height={45} />
      </Column>
    </Column>
  );
}

export default LoadingTeam;
